/*
 * WOOOF CUSTOM — Category header tabs (Dog / Cat / Shop by Brand)
 * Depends on StaticHeader / NavMobile changes in assets/empire.js (search: "WOOOF CUSTOM").
 * Calls header.__staticHeader.reinitDesktopNav() and reinitMobileNav() after tab switch.
 */
(function () {
  var ACTIVE_CLASS = 'is-active';
  var TAB_SELECTOR = '[data-header-category-tab]';
  var DESKTOP_PANEL_SELECTOR = '[data-header-nav-panel]';
  var MOBILE_PANEL_SELECTOR = '[data-mobile-nav-panel-content]';

  function getHeaderInstance(header) {
    return header.__staticHeader || (header.closest('.shopify-section') && header.closest('.shopify-section').__staticHeader);
  }

  function normalizePath(pathname) {
    var path = (pathname || '/').replace(/\/$/, '');
    return path === '' ? '/' : path;
  }

  function isTabLinkPage(url) {
    if (!url) return true;

    try {
      var target = new URL(url, window.location.origin);
      return normalizePath(target.pathname) === normalizePath(window.location.pathname);
    } catch (error) {
      return window.location.href.indexOf(url) !== -1;
    }
  }

  function getTabRedirectUrl(header, tabId) {
    if (tabId === 'dog') return header.dataset.dogTabUrl || '';
    if (tabId === 'cat') return header.dataset.catTabUrl || '';
    if (tabId === 'brands') return header.dataset.brandsTabUrl || '';
    return '';
  }

  function reinitHeaderNav(header) {
    var headerInstance = getHeaderInstance(header);
    if (!headerInstance) return;

    if (typeof headerInstance.reinitDesktopNav === 'function') {
      headerInstance.reinitDesktopNav();
    }
    if (typeof headerInstance.reinitMobileNav === 'function') {
      headerInstance.reinitMobileNav();
    }
  }

  function setActiveTab(header, tabId, options) {
    options = options || {};

    if (!tabId) return;

    var previousTab = header.dataset.activeHeaderCategory;
    var tabChanged = previousTab !== tabId;

    header.dataset.activeHeaderCategory = tabId;

    header.querySelectorAll(TAB_SELECTOR).forEach(function (tab) {
      var isActive = tab.dataset.headerCategoryTab === tabId;
      tab.classList.toggle(ACTIVE_CLASS, isActive);
      tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    header.querySelectorAll(DESKTOP_PANEL_SELECTOR).forEach(function (panel) {
      var isActive = panel.dataset.headerNavPanel === tabId;
      panel.classList.toggle(ACTIVE_CLASS, isActive);
      panel.hidden = !isActive;
    });

    header.querySelectorAll(MOBILE_PANEL_SELECTOR).forEach(function (panel) {
      var isActive = panel.dataset.mobileNavPanelContent === tabId;
      panel.classList.toggle(ACTIVE_CLASS, isActive);
      panel.hidden = !isActive;
    });

    if (!options.skipReinit && tabChanged) {
      reinitHeaderNav(header);
    }
  }

  function initHeaderCategoryNav(header) {
    if (!header || header.dataset.headerCategoryNavInitialized === 'true') return;

    var tabs = header.querySelectorAll(TAB_SELECTOR);
    if (!tabs.length) return;

    var activeTab = header.querySelector(TAB_SELECTOR + '.' + ACTIVE_CLASS);
    var defaultTab =
      header.dataset.defaultHeaderCategory ||
      (activeTab && activeTab.dataset.headerCategoryTab) ||
      tabs[0].dataset.headerCategoryTab;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();

        var tabId = tab.dataset.headerCategoryTab;
        var redirectUrl = getTabRedirectUrl(header, tabId);

        if (redirectUrl && !isTabLinkPage(redirectUrl)) {
          window.location.assign(redirectUrl);
          return;
        }

        setActiveTab(header, tabId);
      });
    });

    setActiveTab(header, defaultTab, { skipReinit: true });
    header.dataset.headerCategoryNavInitialized = 'true';
  }

  function initAllHeaders() {
    document.querySelectorAll('[data-site-header]').forEach(initHeaderCategoryNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHeaders);
  } else {
    initAllHeaders();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector('[data-site-header]');
    if (header) {
      header.dataset.headerCategoryNavInitialized = 'false';
      initHeaderCategoryNav(header);
    }
  });
})();
